/* eslint-disable */
import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";
import loginBg from "../assets/parent-login-bg.png";
import presentPlusLogo from "../assets/presentplus-logo-white.png";
import "./ParentForgotPassword.css";

function MailIcon() {
  return (
    <svg
      viewBox="0 0 24 24"
      className="pp-forgot-field-icon"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M4 6h16v12H4z" />
      <path d="m5 7 7 6 7-6" />
    </svg>
  );
}

export default function ParentForgotPassword() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const canSubmit = useMemo(() => Boolean(email.trim()), [email]);

  async function handleSubmit(e) {
    e.preventDefault();
    if (!canSubmit) return;

    setLoading(true);
    setError("");
    setSuccess("");

    try {
      const requestReset = httpsCallable(functions, "requestParentPasswordReset");
      await requestReset({ email: email.trim() });

      setSuccess("If that email exists, a reset link has been sent.");
    } catch {
      setError("Unable to send reset link right now.");
    }

    setLoading(false);
  }

  return (
    <div className="pp-forgot-page">
      <div
        className="pp-forgot-card"
        style={{ backgroundImage: `url(${loginBg})` }}
      >
        <div className="pp-forgot-top">
          <div className="pp-forgot-logo-wrap">
            <img
              src={presentPlusLogo}
              alt="PresentPlus"
              className="pp-forgot-logo"
            />
          </div>

          <div className="pp-forgot-hero">
            <h1 className="pp-forgot-title">Forgot password?</h1>
            <p className="pp-forgot-subtitle">
              Enter your email and we’ll send you a reset link.
            </p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="pp-forgot-form pp-forgot-form-panel">
          <div className="pp-forgot-input-wrap">
            <span className="pp-forgot-icon-wrap">
              <MailIcon />
            </span>

            <input
              className="pp-forgot-input"
              type="email"
              placeholder="Email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          {error ? <div className="pp-forgot-error">{error}</div> : null}
          {success ? <div className="pp-forgot-success">{success}</div> : null}

          <button
            type="submit"
            className="pp-forgot-submit"
            disabled={!canSubmit || loading}
          >
            {loading ? "Sending..." : "Send reset link"}
          </button>

          <button
            type="button"
            className="pp-forgot-back"
            onClick={() => navigate("/parent-login")}
          >
            Back to login
          </button>
        </form>
      </div>
    </div>
  );
}